import { entries, isPlainObject } from 'lodash-es';

export const getQueryStringValueByKey = (
  key,
  search = window.location.search
) => {
  if (typeof search === 'string' && typeof key === 'string') {
    const searchKeyValues = search.slice(1).split('&');

    for (const searchKeyValue of searchKeyValues) {
      const [searchKey, searchValue = null] = searchKeyValue.split('=');

      if (searchKey === key) {
        return searchValue === null ? true : searchValue;
      }
    }
  }

  return null;
};

export const formatQueryStringParams = (params = {}, prefix = '?') => {
  if (!isPlainObject(params)) {
    throw new Error('Params must be an object');
  }

  return entries(params).reduce(
    (acc, [key, value], i) =>
      acc + `${(i === 0 ? prefix : '&') + key}=${encodeURIComponent(value)}`,
    ''
  );
};

export const getApiEndpoint = () => {
  const href = window.location.href;
  const homepage = typeof __HOMEPAGE__ !== 'undefined' ? __HOMEPAGE__ : '';
  const index = homepage ? href.indexOf(homepage) : -1;
  const basePath = index >= 0 ? href.slice(0, index + homepage.length) : href;
  if (process.env.REACT_APP_CREATE_MOCK_SERVER === 'true') {
    return basePath.replace(/\/+$/, '');
  }
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  if (!apiEndpoint) {
    throw new Error('REACT_APP_API_ENDPOINT is not defined');
  }
  return apiEndpoint.replace(/\/+$/, '');
};

export const getLoginUrl = (baseUrl) => {
  const redirectUrl = process.env.REACT_APP_CLIENT_REDIRECT_LOGIN_URL;
  const paramConnector = baseUrl.match(/\?./) ? '&' : '?';
  return `${baseUrl}${paramConnector}targetAuthLevel=40&destinationURL='&__EntryPageParams=returnUrl:${redirectUrl}`;
};
